// HKDSE Other Subjects Mock Data
// 香港中學文憑考試 其他科目 模擬數據

export const hkdseOtherExams = [
  // HKDSE Chinese Language
  {
    id: 6,
    name: 'HKDSE 中國語文',
    nameEn: 'HKDSE Chinese Language',
    nameCn: 'HKDSE 中国语文',
    nameJa: 'HKDSE 中国語',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: '測試中文閱讀理解、語文運用和文學賞析能力',
    modes: {
      examMode: { name: '考試模式', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "下列哪個詞語的讀音正確？",
        questionEn: "Which of the following words has the correct pronunciation?",
        hasAudio: true,
        audioUrl: "/audio/chinese/pronunciation1.mp3",
        options: ["載(zài)重", "載(zǎi)重", "載(zài)歌載舞", "記載(zài)"],
        correctAnswer: 0,
        explanation: "「載重」應讀作「zài」，表示承受重量。",
        explanationEn: "\"載重\" should be pronounced as \"zài\", meaning to bear weight.",
        difficulty: "medium",
        topic: "語音知識"
      }
      // More questions...
    ]
  },

  // HKDSE English Language
  {
    id: 7,
    name: 'HKDSE English Language',
    nameEn: 'HKDSE English Language',
    nameCn: 'HKDSE 英语',
    nameJa: 'HKDSE 英語',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: '測試英語聽說讀寫綜合能力',
    modes: {
      examMode: { name: 'Exam Mode', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: 'Study Mode', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: 'Pre-test Mode', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "Listen to the conversation and choose the best answer:",
        questionEn: "Listen to the conversation and choose the best answer:",
        hasAudio: true,
        audioUrl: "/audio/english/listening1.mp3",
        options: [
          "The meeting is at 3 PM",
          "The meeting is at 2 PM", 
          "The meeting is cancelled",
          "The meeting is postponed"
        ],
        correctAnswer: 1,
        explanation: "The speaker clearly states the meeting time as 2 PM.",
        explanationEn: "The speaker clearly states the meeting time as 2 PM.",
        difficulty: "medium",
        topic: "Listening Comprehension"
      }
      // More questions...
    ]
  },

  // HKDSE Physics
  {
    id: 8,
    name: 'HKDSE Physics',
    nameEn: 'HKDSE Physics',
    nameCn: 'HKDSE 物理',
    nameJa: 'HKDSE 物理学',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'science',
    difficulty: 'advanced',
    description: '測試物理原理、公式應用和實驗分析能力',
    modes: {
      examMode: { name: '考試模式', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "一個物體以初速度 \\(v_0 = 10\\) m/s 垂直向上拋射，重力加速度 \\(g = 10\\) m/s²，求物體到達最高點的時間：",
        questionEn: "An object is thrown vertically upward with initial velocity \\(v_0 = 10\\) m/s. Given \\(g = 10\\) m/s², find the time to reach maximum height:",
        svgDiagram: `
          <svg width="300" height="250" viewBox="0 0 300 250">
            <defs>
              <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="10" refY="3.5" orient="auto">
                <polygon points="0 0, 10 3.5, 0 7" fill="#ef4444"/>
              </marker>
            </defs>
            <!-- Ground -->
            <line x1="50" y1="220" x2="250" y2="220" stroke="#8b5cf6" stroke-width="3"/>
            <text x="150" y="240" text-anchor="middle" font-size="14">地面</text>
            <!-- Object trajectory -->
            <path d="M 150 220 Q 150 100 150 50" fill="none" stroke="#3b82f6" stroke-width="2" stroke-dasharray="5,5"/>
            <!-- Initial velocity arrow -->
            <line x1="150" y1="220" x2="150" y2="180" stroke="#ef4444" stroke-width="3" marker-end="url(#arrowhead)"/>
            <text x="160" y="200" font-size="12" fill="#ef4444">v₀ = 10 m/s</text>
            <!-- Object at different positions -->
            <circle cx="150" cy="220" r="5" fill="#10b981"/>
            <circle cx="150" cy="135" r="4" fill="#3b82f6" opacity="0.7"/>
            <circle cx="150" cy="50" r="4" fill="#ef4444"/>
            <text x="160" y="55" font-size="12">最高點</text>
            <!-- Gravity arrow -->
            <line x1="200" y1="100" x2="200" y2="130" stroke="#f59e0b" stroke-width="2" marker-end="url(#arrowhead)"/>
            <text x="205" y="120" font-size="12" fill="#f59e0b">g</text>
          </svg>
        `,
        options: [
          "\\(1\\) 秒",
          "\\(2\\) 秒", 
          "\\(0.5\\) 秒",
          "\\(1.5\\) 秒"
        ],
        correctAnswer: 0,
        explanation: "在最高點時，速度為零。使用公式 \\(v = v_0 - gt\\)，得 \\(0 = 10 - 10t\\)，解得 \\(t = 1\\) 秒",
        explanationEn: "At maximum height, velocity is zero. Using \\(v = v_0 - gt\\), we get \\(0 = 10 - 10t\\), so \\(t = 1\\) second",
        difficulty: "medium",
        topic: "運動學",
        hasMath: true,
        hasSvg: true
      }
      // More questions...
    ]
  }
]; 